import styled from 'styled-components'

const Topbar = styled.div`
  top: 0;
  left: 0;
  z-index: 1000;
  position: sticky;
  width: 100%;
  background: yellow;
  text-align: center;
  color: black;
  display: flex;
  flex-direction: row;
  align-items: baseline;
  justify-content: center;
`

export const AWSAccountBanner: React.FC = () => {
  return <Topbar>NEW AWS ACCOUNT</Topbar>
}
